import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { RoutingRuleAction } from '@cbridge-packages/routing-rules';
import { RulesManagementAction, makeRuleRowModelAndState } from '@cbridge-modules/rules-management-page';

export const onLoadRoutingRulesDoneEpic: IEpic = (action$) => action$.pipe(
  isTypeOfAndGetPayload(
    RoutingRuleAction.loadList.done,
  ),
  mergeMap((payload) => {
    const { rows, initialState } = makeRuleRowModelAndState(payload.result);
    return [
      RulesManagementAction.updateState({ ...initialState, rules: rows }),
    ];
  }),
);
